// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1JH5R","resendInfoText":"OnGoingPaymentBox_resendInfoText__2IWPT"};